import React from 'react';

import { PaginationContext } from 'src/providers/PaginationProvider';

export const usePagination = () => {
  return React.use(PaginationContext);
};
